
import * as moment from "moment";

import { IVehicle } from "@interfaces/IVehicle";

export interface IVehicleData {
    Id: number;

    LastUpdated: Date;

    VehicleId: number;

    Registration: string;

    Vehicle: IVehicle;

    Width: string;

    Wheelbase: string;

    Weight: string;

    Vin: string;

    VehicleYear: string;

    VehicleType: string;

    VehicleGrossWeight: string;

    Valves: string;

    //ValidTax: boolean;

    //ValidMot: boolean;

    VRM: string;

    UrbanColdMpg: string;

    TransmissionType: string;

    TrailerUnbraked: string;

    TrailerBraked: string;

    TorqueRpm: string;

    TorqueNm: string;

    TorqueLbFt: string;

    TaxStatus: string;

    TaxExpiry: Date;

    NumberOfSeats: string;

    MotStatus: string;

    MotExpiry: Date;

    ModelversionToYear: string;

    ModelversionToMonth: string;

    ModelVersionNumber: string;

    ModelVersionFromYear: string;

    ModelVersionFromMonth: string;

    Model: string;

    MaxTechMass: string;

    MaxSpeedMph: string;

    MaxNetPower: string;

    MassInService: string;

    ManufacturerVersionCode: string;

    Make: string;

    Length: string;

    Kw: string;

    ImageName: string;

    Height: string;

    Gears: string;

    FuelDelivery: string;

    Fuel: string;

    ExtraUrbanMpg: string;

    ExactCc: string;

    EuroStatus: string;

    EngineSizeDescripion: string;

    EngineNumber: string;

    EngineMake: string;

    EngineCode: string;

    EngineAlignment: string;

    DvlaModel: string;

    DvlaMake: string;

    DriveType: string;

    Doors: string;

    Derivative: string;

    DateOfRegistration: string;

    Cylinders: string;

    CountryOfOrigin: string;

    CombinedMpg: string;

    Colour: string;

    Co2: string;

    Cc: string;

    Bore: string;

    BodyStyle: string;

    Bhp: string;

    AxleName: string;

    AccelerationMph: string;
    
    motExpirationStatus: DataValidationStatus;
    taxExpirationStatus: DataValidationStatus;
}

export enum DataValidationStatus {
    NoDetailsFound,
    Valid,
    DueSoon,
    Expired
}
